import { Capacitor } from "@capacitor/core";

const WEB_API_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

const MOBILE_API_URL =
  process.env.REACT_APP_MOBILE_API_URL ||
  WEB_API_URL;

export const API_URL =
  Capacitor.isNativePlatform()
    ? MOBILE_API_URL
    : WEB_API_URL;

export const API_BASE =
  `${API_URL}/api`;

export const UPLOADS_URL =
  `${API_URL}/uploads`;
